import React from 'react';
import { Modal, Text, TextInput, Group, ActionIcon } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { IconCopy } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export default function ShareCalendarModal({ opened, onClose, shareCode }) {
  const { t } = useTranslation('common');
  const clipboard = useClipboard({ timeout: 2000 });
  const sectionWidth = clipboard.copied ? 60 : 32;
  return (
    <Modal opened={opened} onClose={onClose} title={t('share.title')}>
      <Text mb="sm">{t('share.instruction')}</Text>
      <Group align="center" gap="sm">
        <TextInput
          value={shareCode}
          readOnly
          style={{ flex: 1 }}
          rightSection={
            clipboard.copied ? (
              <span style={{ fontSize: 12, color: '#0ca678', fontWeight: 600, whiteSpace: 'nowrap' }}>{t('share.copied')}</span>
            ) : (
              <ActionIcon
                variant="subtle"
                size="sm"
                onClick={() => clipboard.copy(shareCode)}
                title={t('share.copy_title')}
                aria-label={t('share.copy_aria')}
              >
                <IconCopy size={16} />
              </ActionIcon>
            )
          }
          rightSectionWidth={sectionWidth}
          styles={{
            section: { right: 4 },
            input: { paddingRight: sectionWidth + 8 },
          }}
        />
      </Group>
    </Modal>
  );
}
